import React, { Context } from 'react';

import { AuthContextData } from '@onArte/frontend/types';

export const AuthContext: Context<AuthContextData> = React.createContext<AuthContextData>([
  { userData: null, token: null, tokenExpiration: null }, (): void => undefined,
]);
